export default __webpack_public_path__ + "static/media/3233 knife block B top.f20caf91.png";